// @ts-strict-ignore
import Select from 'antd/lib/select';
import * as React from 'react';
import { SelectableCommit } from '../types';
import { shortCommitHashFromHash } from '../helpers/displayHelpers';
import Text from 'antd/lib/typography/Text';

export interface CommitSelectorProps {
    loading: boolean;
    disabled: boolean;
    commits: SelectableCommit[];
    disableMatchingHash?: string;
    style: React.CSSProperties;
    multiSelect?: boolean;
    allowSearch?: boolean;
    searchValue?: string;
    onSearch?: (value: string) => void;
}

export const CommitSelector: React.FC<CommitSelectorProps> = ({
    loading,
    disabled,
    commits,
    disableMatchingHash,
    style,
    multiSelect,
    allowSearch,
    searchValue,
    onSearch,
    ...rest
}) => {
    return (
        <Select
            style={style}
            placeholder={
                loading ? 'Loading commits...'
                : commits.length == 0 ?
                    'No commits found'
                :   'Select a commit'
            }
            loading={loading}
            disabled={disabled}
            mode={multiSelect ? 'multiple' : null}
            filterOption={(input, option) => {
                return (option.key as string)?.toLowerCase().includes(input.toLowerCase());
            }}
            showSearch={allowSearch}
            searchValue={searchValue}
            onSearch={onSearch}
            {...rest}
        >
            {commits.map((selectableCommit, index) => {
                return (
                    <Select.Option
                        value={selectableCommit.hash}
                        key={selectableCommit.hash + '-' + selectableCommit.message}
                        disabled={disableMatchingHash ? disableMatchingHash === selectableCommit.hash : false}
                    >
                        <Text
                            ellipsis={{
                                tooltip: {
                                    title: selectableCommit.message,
                                    placement: 'right',
                                },
                            }}
                        >
                            <Text code>{shortCommitHashFromHash(selectableCommit.hash)}</Text>
                            {index === 0 && <Text strong> (HEAD)</Text>}
                            <Text> - {selectableCommit.message}</Text>
                        </Text>
                    </Select.Option>
                );
            })}
        </Select>
    );
};
